import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  viewChild,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import {
  CONFIRM_DIALOG_MESSAGE,
  CONFIRM_DIALOG_MESSAGE_DELETE,
} from "../../locale/consts.en";
import { ItemEditComponent } from "../item-edit/item-edit.component";
import { MasterDataService } from "../master-data/master-data-service";
import { Attribute, AttributeType } from "../master-data/master-data.model";
import {
  ConfDialogType,
  ConfirmDialogModel,
} from "../shared/confirm-dialog/confim-dialog.model";
import { ConfirmDialogComponent } from "../shared/confirm-dialog/confirm-dialog.component";
import { sortByStringWithEmptyAtEnd } from "../shared/helpers/helper-functions";

@Component({
  selector: "app-installation-attributes",
  templateUrl: "./installation-attributes.component.html",
  styleUrls: ["./installation-attributes.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class InstallationAttributesComponent implements OnInit, AfterViewInit {
  private dialog = inject(MatDialog);
  private masterDataService = inject(MasterDataService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  readonly sort = viewChild(MatSort);
  dataSource: MatTableDataSource<Attribute>;
  displayedColumns: string[] = [
    "name",
    "externalId",
    "renderTag",
    "edit",
    "delete",
  ];
  installationAttributes: Attribute[] = [];

  ngOnInit(): void {
    const installationAttributes =
      this.route.snapshot.data.installationAttributes ?? [];
    this.installationAttributes = sortByStringWithEmptyAtEnd(
      installationAttributes,
      (item) => item.name,
    );
    // this.route.snapshot.data.installationAttributes.sort((a, b) =>
    //   a.name.localeCompare(b.name)
    // );
    this.dataSource = new MatTableDataSource(this.installationAttributes);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  saveUserAttributeToApi(attr: Attribute) {
    if (attr.type == null || attr.type !== AttributeType.INSTALLATION) {
      attr.type = AttributeType.INSTALLATION;
    }
    this.masterDataService
      .updateAttribute(attr)
      .pipe(
        finalize(() => {
          this.masterDataService
            .getInstallationAttribute()
            .subscribe((attrs) => {
              this.installationAttributes = attrs;
              this.dataSource.data = this.installationAttributes;
            });
        }),
      )
      .subscribe({
        next: (response) => {
          this.masterDataService.handleResponse(response);
        },
        error: (_) => this.masterDataService.savingErrorMessage(),
      });
  }

  updateAttribute(t: Attribute) {
    const userAttr = new Attribute();
    Object.assign(userAttr, t);
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: userAttr,
    });
    dialogRef.afterClosed().subscribe(async (data: Attribute) => {
      if (data != null) {
        this.saveUserAttributeToApi(data);
      }
    });
  }

  deleteAttribute(attribute: Attribute) {
    const dialogData = new ConfirmDialogModel(
      CONFIRM_DIALOG_MESSAGE,
      CONFIRM_DIALOG_MESSAGE_DELETE,
      ConfDialogType.MESSAGE,
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
  }

  onAddAttribute() {
    const attr = new Attribute();
    const dialogRef = this.dialog.open(ItemEditComponent, {
      width: "20vw",
      data: attr,
    });
    dialogRef.afterClosed().subscribe(async (data: Attribute) => {
      if (data != null) {
        data.type = AttributeType.INSTALLATION;
        this.saveUserAttributeToApi(data);
      }
    });
  }

  onBack() {
    this.router.navigate(["/"]);
  }
}
